import { format } from "date-fns";
import { Campaign, Note, Person, Sales } from "../types/person";
import api from "./api";

export const listCampaignsPerson = async (id: number): Promise<Campaign[]> => {
  const response = await api.get(
    "pessoa-p1-:stage/:stage/crm/perfil/getCampanhasSMSById",
    { params: { idPerson: id } }
  );
  return response.data;
};

export const listNotesPerson = async (id: number): Promise<Note[]> => {
  const response = await api.get("pessoa-p2-:stage/:stage/crm/getPessoasNota", {
    params: { id_pessoa: id },
  });
  return response.data?.pessoaNota;
};

export const listSalesPerson = async (id: number): Promise<Sales> => {
  const response = await api.get("pessoa-p1-:stage/:stage/crm/perfil/getById", {
    params: { idPerson: id },
  });
  return response.data;
};

export const getPerson = async (data: Person): Promise<any> => {
  const response = await api.get("pessoa-p2-:stage/:stage/crm/getPessoaByDoc", {
    params: { idPerson: data.id_pessoa, document: data.documento },
  });
  return response.data;
};

export const deletePerson = async (person): Promise<any> => {
  const objectRequestData = {
    documento: person.document,
    motivo: person.reason,
    pessoa: person.id,
  };
  const response = await api.delete(
    "pessoa-p2-:stage/:stage/crm/deletePessoa",
    {
      data: objectRequestData,
    }
  );
  return response.data;
};

export const updatePerson = async (person): Promise<any> => {
  const objectRequestData = {
    bairro: person.bairro,
    blacklist_email: person.blacklist_email,
    blacklist_sms: person.blacklist_sms,
    celular1: person.celular1,
    cep: person.cep,
    cidade: person.cidade,
    data_nascimento: format(person.data_nascimento, "dd/MM/yyyy"),
    documento: person.documento.replace(/[^0-9]/g, ""),
    documentoMotivo: person.document,
    email1: person.email1,
    id_pessoa: person.id_pessoa,
    motivo: person.reason,
    nome: person.nome,
    rua: person.rua,
    sexo: person.sexo?.value,
    uf: person.uf,
  };

  const response = await api.put(
    "pessoa-p1-:stage/:stage/crm/putPessoa",
    objectRequestData
  );
  return response.data;
};

export const newPersonService = async (person): Promise<any> => {
  const objectRequestData = {
    bairro: person.bairro,
    blacklist_email: person.blacklist_email,
    blacklist_sms: person.blacklist_sms,
    celular1: person.celular1,
    cep: person.cep,
    cidade: person.cidade,
    data_nascimento: format(person.data_nascimento, "yyyy-MM-dd"),
    documento: person.documento.replace(/[^0-9]/g, ""),
    email1: person.email1,
    nome: person.nome,
    rua: person.rua,
    sexo: person.sexo?.value,
    uf: person.uf,
    telefone1: person.telefone1,
    complemento: person.complemento,
  };

  const response = await api.post(
    "pessoa-p1-:stage/:stage/crm/postPessoa",
    objectRequestData
  );
  return response.data;
};

export const createNote = async (note): Promise<any> => {
  const response = await api.post(
    "pessoa-p2-:stage/:stage/crm/postPessoaNota",
    note
  );
  return response.data;
};

export const updateNote = async (note): Promise<any> => {
  const response = await api.put(
    "pessoa-p2-:stage/:stage/crm/putPessoaNota",
    note
  );
  return response.data;
};

export const deleteNote = async (note): Promise<any> => {
  const response = await api.delete(
    "pessoa-p2-:stage/:stage/crm/deletePessoaNota",
    {
      data: note,
    }
  );
  return response.data;
};
